import React from "react";
import {
  BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer, Cell,
} from "recharts";

const COLORS = ["#48A0DC", "#2B7AB5", "#1A5A8A", "#F59E0B", "#D97706", "#10B981", "#8B5CF6", "#EC4899"];

function SMSourcePerformance({ items, loading, error, onSourceClick, onCellClick }) {
  const data = Array.isArray(items) ? items : [];

  const handleBarClick = (entry) => {
    if (!entry || !entry.source) return;
    onSourceClick && onSourceClick(entry.source);
  };

  return (
    <div className="dashboard-card-v2">
      <div className="dashboard-card-v2-header">
        <i className="fas fa-chart-bar" />
        <span>Source Performance</span>
        <span className="dashboard-card-v2-count">{data.length} sources</span>
      </div>
      <div className="dashboard-card-v2-body">
        {error ? (
          <div className="dashboard-error">
            <i className="fas fa-exclamation-circle" /> {error}
          </div>
        ) : loading ? (
          <div className="dashboard-skeleton-block" style={{ height: 220 }} />
        ) : data.length === 0 ? (
          <div className="dashboard-empty">
            <i className="fas fa-chart-bar" />
            <p>No source data.</p>
          </div>
        ) : (
          <>
            <div style={{ width: "100%", height: 220 }}>
              <ResponsiveContainer>
                <BarChart data={data} margin={{ top: 12, right: 16, left: 0, bottom: 0 }}>
                 <XAxis
                      dataKey="source"
                      tick={{ fontSize: 11 }}
                      interval={0}
                      angle={-30}
                      textAnchor="end"
                      height={60}
                    />
                  <YAxis tick={{ fontSize: 11 }} allowDecimals={false} />
                  <Tooltip
                    formatter={(value, name) => [`${value} leads — click to view`, name]}
                    labelFormatter={(l) => `Source: ${l}`}
                  />
                  <Bar
                    dataKey="total"
                    radius={[6, 6, 0, 0]}
                    onClick={handleBarClick}
                    cursor="pointer"
                  >
                    {data.map((_, i) => (
                      <Cell key={i} fill={COLORS[i % COLORS.length]} />
                    ))}
                  </Bar>
                </BarChart>
              </ResponsiveContainer>
            </div>
            <div className="sm-source-table">
              {data.map((s) => (
                <div
                  key={s.source}
                  className="sm-source-row sm-source-row-clickable"
                  onClick={() => onSourceClick && onSourceClick(s.source)}
                >
                  <span className="sm-source-name">{s.source}</span>
                  <span>{s.total} total</span>
                  <span
                    className="sm-source-cell-clickable"
                    onClick={(e) => {
                      e.stopPropagation();
                      onCellClick && onCellClick(s.source, "won");
                    }}
                  >
                    {s.won} won ({s.conversion}%)
                  </span>
                  <span className="sm-source-open">{s.open} open</span>
                </div>
              ))}
            </div>
          </>
        )}
      </div>
    </div>
  );
}

export default SMSourcePerformance;